import { config } from '../../../config/config';
import { loadScript } from '../../shared/utils/scripts';

let XTREME_PUSH_LOADED: null | Promise<void> = null;
export async function getXtremePush() {
    if (!XTREME_PUSH_LOADED) {
        const xtremePushUrl = config.XTREMEPUSH_URL;
        XTREME_PUSH_LOADED = loadScript(xtremePushUrl);
    }

    await XTREME_PUSH_LOADED;

    return window.xtremepush;
}
